import { PagedSingleSelectField, laravelSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { eventService } from "../api/event/eventService";

interface Props {
	name: string;
	label: string;
	clearable?: boolean;
	required?: boolean;
	disabled?: boolean;
}

export const EventWithPMSingleSelect: FC<Props> = ({ name, label, clearable, required, disabled }) => {
	return (
		<PagedSingleSelectField
			name={name}
			label={label}
			clearable={clearable}
			required={required}
			disabled={disabled}
			fetchConfig={laravelSelectFetchConfig(eventService.optionsWithParticipantManagementKey, (search, page) =>
				eventService.optionsWithParticipantManagement(search, page).then(({ data }) => data),
			)}
		/>
	);
};
